var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61.383331mm",
    height: "61.38332mm",
    viewBox: "0 0 61.383331 61.38332",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-173.71837,-149.01066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 174.49177,209.62058 c -0.61522,-0.61522 -0.7734,-1.0063 -0.7734,-1.91217 v -1.13877 l 13.4241,-13.43366 13.4241,-13.43367 -13.4241,-13.43366 -13.4241,-13.43366 v -1.13878 c 0,-1.60752 1.07805,-2.68556 2.68557,-2.68556 h 1.13877 l 13.43367,13.42409 13.43366,13.4241 13.43367,-13.4241 13.43366,-13.42409 h 1.13877 c 1.60752,0 2.68557,1.07804 2.68557,2.68556 v 1.13878 l -13.4241,13.43366 -13.42409,13.43366 13.42409,13.43367 13.4241,13.43366 v 1.13877 c 0,1.60752 -1.07805,2.68557 -2.68557,2.68557 h -1.13877 l -13.43366,-13.4241 -13.43367,-13.42409 -13.43366,13.42409 -13.43367,13.4241 h -1.13877 c -0.90587,0 -1.29695,-0.15818 -1.91217,-0.7734 z",
    id: "path1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f41fb96cdb281438da5151669fc34993.svg";
export { ForwardRef as ReactComponent };